import { L } from '@execonline-inc/translations';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ScheduledProgramInstanceOption } from '../../../../../../../Types';
import { utcDateToLocalDate } from '../../../../../../Functions';

interface Props {
  instances: ScheduledProgramInstanceOption[];
}

const DateList: React.FC<Props> = ({ instances }) => (
  <ul className={clsx('items-center self-stretch px-2')}>
    {instances.map((instance) => (
      <li key={instance.id} className={clsx('p-2')}>
        <L localizeable={utcDateToLocalDate(instance.startOn)} format={'long-weekday-month-year'} />
      </li>
    ))}
  </ul>
);

export default observer(DateList);
